import { colors } from "@/src/utils/colors"

export type Logger = {
  error: (...args: unknown[]) => void
  warn: (...args: unknown[]) => void
  info: (...args: unknown[]) => void
  success: (...args: unknown[]) => void
  log: (...args: unknown[]) => void
  break: () => void
}

const join = (args: unknown[]) => args.map(String).join(" ")

export const logger: Logger = {
  error(...args: unknown[]) {
    console.log(colors.red(join(args)))
  },
  warn(...args: unknown[]) {
    console.log(colors.yellow(join(args)))
  },
  info(...args: unknown[]) {
    console.log(colors.cyan(join(args)))
  },
  success(...args: unknown[]) {
    console.log(colors.green(join(args)))
  },
  log(...args: unknown[]) {
    console.log(join(args))
  },
  break() {
    console.log("")
  },
}
